import styled from 'styled-components';

export const BackgroundContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: #f5f5f5;
`;
